import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { globalRoles, userRoles } from 'interfaces/user';
import MenuIcon from 'mdi-react/MenuIcon';
import React, { memo, useContext } from 'react';
import { useObservable } from 'react-use-observable';
import rxjsOperators from 'rxjs-operators';
import authService from 'services/auth';

import { DrawerContext } from '../Drawer';
import VentureSelection from '../Drawer/VentureSelection';
import ScreenshotButton from './ScreenshotButton';
import Breadcrumbs, { IBreadcrumb } from './Breadcrumbs';

interface IProps {
  title?: string;
  classes?: any;
  children?: JSX.Element;
  breadcrumbs?: IBreadcrumb[];
  hideVentureSelect?: boolean;
  containerToPrint?: React.RefObject<any>;
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: theme.variables.headerHeight,
    marginBottom: theme.spacing(2),
  },
  appBar: {
    marginLeft: theme.variables.drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${theme.variables.drawerWidth}px)`,
    },
  },
  title: {
    fontWeight: 700,
  },
}));

const Toolbar = memo(
  ({
    title,
    children,
    breadcrumbs = [],
    containerToPrint,
    hideVentureSelect,
  }: IProps) => {
    const classes = useStyles({});
    const drawer = useContext(DrawerContext);

    const [user] = useObservable(() => {
      return authService.getUser().pipe(rxjsOperators.logError());
    }, []);

    const canSelectVenture =
      user &&
      ([...globalRoles, userRoles.auditor].some((role) =>
        user.roles.includes(role)
      ) ||
        (user.ventures && user.ventures.length > 1));

    const openDrawer = () => {
      drawer.open();
    };

    return (
      <div className={classes.root}>
        <Grid container alignItems="center" justify="center">
          <Hidden mdUp>
            <Grid item xs="auto">
              <IconButton color="inherit" onClick={openDrawer}>
                <MenuIcon />
              </IconButton>
            </Grid>
          </Hidden>
          <Grid item xs={true}>
            {children}
            {!children && (
              <Typography
                className={classes.title}
                variant="h6"
                color="primary"
                noWrap
              >
                {title || 'App'}
              </Typography>
            )}
            <Hidden xsDown>
              <Breadcrumbs breadcrumbs={breadcrumbs} />
            </Hidden>
          </Grid>

          {containerToPrint && (
            <Grid item>
              <ScreenshotButton containerToPrint={containerToPrint} />
            </Grid>
          )}

          {!hideVentureSelect && (
            <Hidden xsDown>
              <Grid item>
                <VentureSelection disabled={!canSelectVenture} />
              </Grid>
            </Hidden>
          )}
        </Grid>
      </div>
    );
  }
);

export default Toolbar;
